import type { ReactElement } from 'react';
import { Button } from '@/shared/ui';
import type { ImageEntry } from '../model/image-entries';

interface ImageEntryItemProps {
  readonly entry: ImageEntry;
  readonly index: number;
  readonly onMove: (index: number, direction: -1 | 1) => void;
  readonly onRemove: (key: string) => void;
}

/** 대표사진 한 장 — 미리보기·순서 이동·제거. 저장 전 업로드는 배지로 표시한다. */
export const ImageEntryItem = ({
  entry,
  index,
  onMove,
  onRemove,
}: ImageEntryItemProps): ReactElement => {
  const previewUrl = entry.kind === 'saved' ? entry.url : entry.localUrl;

  return (
    <li className="flex flex-col items-center gap-1">
      <span className="relative">
        <img
          src={previewUrl}
          alt={`대표사진 ${index + 1}`}
          className="size-20 rounded border object-cover"
        />
        {entry.kind === 'new' ? (
          <span className="absolute bottom-0 inset-x-0 rounded-b bg-foreground/70 text-center text-[10px] text-background">
            저장 필요
          </span>
        ) : null}
      </span>
      <span className="flex gap-0.5">
        <Button
          variant="ghost"
          size="sm"
          aria-label={`대표사진 ${index + 1} 앞으로`}
          onClick={() => onMove(index, -1)}
        >
          ←
        </Button>
        <Button
          variant="ghost"
          size="sm"
          aria-label={`대표사진 ${index + 1} 뒤로`}
          onClick={() => onMove(index, 1)}
        >
          →
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="text-destructive"
          aria-label={`대표사진 ${index + 1} 제거`}
          onClick={() => onRemove(entry.key)}
        >
          ✕
        </Button>
      </span>
    </li>
  );
};
